import { ArrowRight, PhoneCall } from "lucide-react";
import { FadeIn } from "@/components/Reveal";
import { SITE } from "@/config/site";

export const FinalCTA = () => (
  <section id="get-started" className="noise-dark relative overflow-hidden bg-navydeep py-24 text-white lg:py-36">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-48 bottom-0 h-[480px] w-[480px] rounded-full border border-gold/15"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-36 bottom-0 h-[350px] w-[350px] rounded-full border border-gold/25"
    />
    <div className="container-tsm relative flex flex-col items-center text-center">
      <FadeIn>
        <p className="eyebrow justify-center">Get Started</p>
        <h2
          className="mx-auto mt-8 max-w-5xl font-serif text-4xl font-semibold leading-[1.06] tracking-tight sm:text-6xl lg:text-7xl"
          data-testid="final-cta-headline"
        >
          Your Business Should Be Ready Before Readiness Becomes{" "}
          <span className="italic text-gold">Urgent.</span>
        </h2>
      </FadeIn>
      <FadeIn delay={0.15}>
        <p className="mx-auto mt-9 max-w-3xl text-base leading-relaxed text-white/70 lg:text-lg" data-testid="final-cta-copy">
          From documentation and compliance support to verification, screening, testing, fingerprinting, and notary
          services, TSM Group CLE helps businesses create stronger operational foundations.
        </p>
      </FadeIn>
      <FadeIn delay={0.3}>
        <div className="mt-11 flex flex-col gap-4 sm:flex-row">
          <a href="#request" data-testid="final-cta-request" className="btn-gold">
            Request a Service
            <ArrowRight className="h-4 w-4" />
          </a>
          <a href={SITE.phoneHref} data-testid="final-cta-call" className="btn-outline-light">
            <PhoneCall className="h-4 w-4" />
            Call TSM Group CLE
          </a>
        </div>
      </FadeIn>
    </div>
  </section>
);
